module.exports = __webpack_public_path__ + "img/banner_bottom.5e68b6e6.png";